import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { CircleNotch } from "@phosphor-icons/react";
import { getMe } from "@/lib/api";

export default function AdminGuard({ children }) {
  const [state, setState] = useState({
    loading: true,
    authenticated: false,
    user: null,
  });

  useEffect(() => {
    getMe()
      .then((r) =>
        setState({
          loading: false,
          authenticated: !!r.authenticated,
          user: r.user || null,
        })
      )
      .catch(() =>
        setState({ loading: false, authenticated: false, user: null })
      );
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
        <CircleNotch size={32} weight="bold" className="animate-spin text-[#EB0D0D]" />
      </div>
    );
  }

  if (!state.authenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return typeof children === "function" ? children(state.user) : children;
}
